const getDomainNameFromURL = () => {
  const hostname = window.location.hostname;

  const hostnameParts = hostname.split(".");

  const hostnameWithoutFirstPart = hostnameParts.slice(1).join(".");

  return `@${hostnameWithoutFirstPart}`;
};

export default getDomainNameFromURL;